import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-inboxintel-deauthorization',
    templateUrl: './inboxintel-deauthorization.component.html',
    styleUrls: ['./inboxintel-deauthorization.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InboxintelDeauthorizationComponent {
    email: string;

    constructor(
        private readonly matDialogRef: MatDialogRef<InboxintelDeauthorizationComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: { email: string },
    ) {
      this.email = this.data.email;
    }

    closeModal(flag?: boolean): void {
        this.matDialogRef.close(flag);
    }
}
